const scheduleServiceModal = {
  title: 'Agendar Serviço',
  scheduleTo: 'Agendar para',
  scheduledDate: 'Data de agendamento',
  schedule: 'Agendar',
  cancel: 'Cancelar',
};

export default scheduleServiceModal;
